export const CHECKLIST_RESPONSE_ACTION_KEYS = [
  "performed",
  "approved",
  "na",
  "deviation",
];

/** Default for existing types/items with no explicit configuration (API + UI). */
export const LEGACY_DEFAULT_ACTION_KEYS = ["approved", "deviation"];

const ALLOWED = new Set(CHECKLIST_RESPONSE_ACTION_KEYS);

export function normalizeActionKeys(value) {
  if (!value || !Array.isArray(value) || value.length === 0) {
    return [...LEGACY_DEFAULT_ACTION_KEYS];
  }
  const out = [...new Set(value.filter((k) => ALLOWED.has(String(k))))];
  return out.length ? out : [...LEGACY_DEFAULT_ACTION_KEYS];
}

/** Checklist type-level defaults (array of keys). */
export function effectiveTypeDefaultActions(checklistType) {
  return normalizeActionKeys(checklistType?.default_response_actions);
}

/**
 * Template row: null/empty `response_actions` means inherit from checklist type defaults.
 */
export function effectiveActionsForTemplateRow(row, typeDefaultKeys) {
  const base = normalizeActionKeys(typeDefaultKeys);
  if (
    row?.response_actions != null &&
    Array.isArray(row.response_actions) &&
    row.response_actions.length > 0
  ) {
    return normalizeActionKeys(row.response_actions);
  }
  return base;
}

/** Instance checklist item: backend stores resolved list; fallback to type. */
export function effectiveActionsForChecklistItem(item, checklistType) {
  if (
    item?.response_actions != null &&
    Array.isArray(item.response_actions) &&
    item.response_actions.length > 0
  ) {
    return normalizeActionKeys(item.response_actions);
  }
  return effectiveTypeDefaultActions(checklistType);
}

const OUTCOME_CODES = new Set([
  "performed",
  "approved",
  "na",
  "deviation",
]);

export function itemRowResolved(item) {
  if (
    item?.isApproved ||
    item?.isDeviation ||
    item?.is_not_applicable
  ) {
    return true;
  }
  const code = item?.response_code;
  return code != null && OUTCOME_CODES.has(String(code));
}

export function toggleKeyInList(list, key) {
  const k = String(key);
  if (!ALLOWED.has(k)) return list;
  const set = new Set(list);
  if (set.has(k)) set.delete(k);
  else set.add(k);
  const next = CHECKLIST_RESPONSE_ACTION_KEYS.filter((x) => set.has(x));
  return next.length ? next : [...LEGACY_DEFAULT_ACTION_KEYS];
}

export function listsEqualAsSets(a, b) {
  const na = normalizeActionKeys(a);
  const nb = normalizeActionKeys(b);
  if (na.length !== nb.length) return false;
  const sa = new Set(na);
  return nb.every((x) => sa.has(x));
}
